module.exports = __webpack_public_path__ + "img/img02.1922a348.png";